import React from 'react'
import { IconWrapper } from './styles'

type Props = {
  color?: string
}

const AddIcon = (props: Props) => {
  return (
    <IconWrapper
      fill={props.color}
      focusable='false'
      viewBox='0 0 24 24'
      aria-hidden='true'
      role='presentation'
    >
      <path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' />
      <path fill='none' d='M0 0h24v24H0z' />
    </IconWrapper>
  )
}

export default AddIcon
